import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Maps from '../../store/map';

class Login extends React.Component {
    state = {
        ...this.state,
        smShow: true,
        checked: true,
    };

    isStayLogin = () => {
        this.setState({ checked: !this.state.checked });
    };

    handleSubmit = (e) => {
        this.props.submitLogin(this.state.inputUsername, this.state.inputPassword);
    };

    handleChange = (e) => {
        this.setState({ ...this.state, [e.target.id]: e.target.value });
    };

    render() {
        let { user } = this.props;
        let smShow = user.data === null;
        let { checked } = this.state;

        return (
            <div>
                <Modal size="sm" show={smShow} onHide={this.props.hideLogin} aria-labelledby="example-modal-sizes-title-sm" centered className="login-modal">
                    <div>
                        <div className="px-4 pt-2 pb-1 text-green">
                            <i className="icon-effebet-logo"></i>
                        </div>
                    </div>
                    <Modal.Body>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                this.handleSubmit();
                            }}
                        >
                            <div className="py-3 px-4">
                                <div className="mt-1">
                                    <input type="text" className="login-input" placeholder="Username" id="inputUsername" onChange={this.handleChange} />
                                </div>
                                <div className="mt-2">
                                    <input type="password" className="login-input" placeholder="Password" id="inputPassword" onChange={this.handleChange} />
                                </div>
                                <div className="fs-13 pt-2">
                                    <label onClick={this.isStayLogin}>
                                        <input type="checkbox" defaultChecked={checked} name="remember" /> Stay logged in
                                    </label>
                                </div>
                                <div className="mg-lg-btn">
                                    <Button className="login-btn" type="submit">
                                        Login
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(Maps.mapUserStateToProps, Maps.mapUserDispatchToProps)(Login);
